
<div class="main">
  <div class="wrapper">
    <div class="global-head-column">
      <div class="global-head-row">
        <div class="page-title">BULK CONFIGURATION</div>
      </div>
    </div>
    <div
      class="message-container"
      i18n="@@admin.bulkconfiguration.fields.warning"
    >
      <p>Changing the configuration applies for ALL users.</p>
    </div>
    <div class="scroll-wrapper">
      <p-table
        #dt
        [columns]="cols"
        dataKey="type"
        [value]="tableData$() | async"
        [scrollable]="true"
        [scrollHeight]="getScrollHeight()"
      >
        <ng-template pTemplate="header" let-columns>
          <th
            *ngFor="let col of columns"
            [class.col--typeName]="col.field == 'bulkConfigurationTypeName'"
            [class.col--displayName]="col.field == 'displayName'"
            [class.col--commandType]="col.field == 'commandType'"
            [class.col--fileNamePrefix]="col.field == 'fileNamePrefix'"
            [class.col--partnerAccessAllowed]="
              col.field == 'partnerAccessAllowed'
            "
          >
            <div class="status-flex">
              <div
                class="horizontal-flex"
                *ngIf="!checkSortIcon(col.field); else filterHeader"
              >
                {{ col.header }}
              </div>
              <ng-template #filterHeader>
                <div
                  class="horizontal-flex clickable"
                  [matMenuTriggerFor]="extendedFilter"
                  #menuTrigger="matMenuTrigger"
                >
                  {{ col.header }}
                  <ng-container
                    *ngIf="{
                      direction: (getFieldSort$(col.field) | async)
                    } as sort"
                  >
                    <mat-icon
                      class="sortIcon {{
                        sort.direction == 1
                          ? 'sort-ascending'
                          : 'sort-descending'
                      }}"
                      *ngIf="sort.direction"
                      >straight</mat-icon
                    >
                  </ng-container>
                  <mat-icon class="material-icons-outlined sortIcon"
                    >filter_alt</mat-icon
                  >
                  <ng-container
                    *ngIf="getFieldFilters$(col.field) | async as filters"
                  >
                    <span *ngIf="filters" class="clear-header-filters"
                      >({{ filters.length }})</span
                    >
                  </ng-container>
                </div>
                <mat-menu
                  class="column-filter-menu"
                  #extendedFilter="matMenu"
                  [hasBackdrop]="true"
                >
                  <app-column-filter
                    *ngIf="menuTrigger.menuOpen"
                    [values]="getFieldValues$(col.field) | async"
                    [template]="getFieldTemplate(col.field)"
                    [canSearch]="getFieldFilterSearch(col.field)"
                    [hasEmptyValue]="getFieldHasEmptyValue(col.field)"
                    [initialSelected]="getFieldFilters$(col.field) | async"
                    [initialSort]="getFieldSort$(col.field) | async"
                    [ignoredValues]="col.ignoredFilterValues"
                    (sort)="setSort(col.field, $event)"
                    (filter)="setFilter(col.field, $event)"
                    (closePopup)="menuTrigger.closeMenu()"
                  ></app-column-filter>
                </mat-menu>
              </ng-template>
            </div>
          </th>
          <th class="col--actions">
            <div class="clear-button">
              <button
                class="clear-button"
                mat-flat-button
                color="warn"
                (click)="clearAllFilter()"
                *ngIf="extendedFilterActive$ | async"
              >
                clear all
              </button>
            </div>
          </th>
        </ng-template>
        <ng-template pTemplate="body" let-setting>
          <tr [pEditableRow]="setting">
            <td class="col--typeName">
              {{ getBulkConfigurationTypeName(setting.bulkConfigurationType) }}
            </td>
            <td class="col--displayName">
              {{ setting.displayName }}
            </td>
            <td class="col--commandType">
              {{ setting.commandType }}
            </td>
            <td class="col--fileNamePrefix">
              {{ setting.fileNamePrefix }}
            </td>
            <td class="col--partnerAccessAllowed">
              <div style="display: flex; flex-direction: row">
                <p-inputSwitch
                  (onChange)="changeBulkConfigurationSetting(setting)"
                  [(ngModel)]="setting.partnerAccessAllowed"
                ></p-inputSwitch>
                <div
                  *ngIf="canShowStateInfo(setting)"
                  style="padding-left: 10px"
                >
                  <mat-icon
                    *ngIf="setting && setting.state == saveStates.ongoing"
                    >autorenew</mat-icon
                  >
                  <mat-icon
                    class="red-icon"
                    *ngIf="setting && setting.state == saveStates.failed"
                    >autorenew</mat-icon
                  >
                  <mat-icon
                    class="green-icon"
                    *ngIf="setting && setting.state == saveStates.done"
                    >autorenew</mat-icon
                  >
                </div>
              </div>
            </td>
            <td class="col--actions">&nbsp;</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
